import { DtoBase } from "../DtoBase";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { DeviceGroupMember } from '../../DiscoveryEngine.TS/Core/DeviceGroupMember';


export class GetDeviceGroupMembersResultDto extends DtoBase {

	public DeviceGroupMembers: List<DeviceGroupMember>;

	constructor() {
		super();

		this.DeviceGroupMembers = new List<DeviceGroupMember>();
	}

	public Write(obj: any, context: any): void {
		obj.get_device_group_members_result = {};
		obj = obj.get_device_group_members_result;

		super.Write(obj, context);

		if (!!this.DeviceGroupMembers && this.DeviceGroupMembers.Count > 0) {
			obj.device_group_members = [];
			ObjSerUtils.WriteObjSerCollection(obj.device_group_members, this.DeviceGroupMembers, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.get_device_group_members_result)
			throw new Error();
		obj = obj.get_device_group_members_result;

		super.Read(obj, context);

		if (obj.device_group_members !== undefined) {
			this.DeviceGroupMembers.Clear();
			ObjSerUtils.ReadObjSerCollection(obj.device_group_members, this.DeviceGroupMembers,
				(value: any) => new DeviceGroupMember(), context);
		}
	}

}